// Copyright 2024 IOTA Stiftung.
// SPDX-License-Identifier: Apache-2.0.

/**
 * Placeholder method which substitutes the type name as a string at runtime.
 * @param property The property to get the name of.
 * @param replaceParent Optional object name to replace the top level object of a property path.
 * @returns The type name as a string.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function nameof<T>(property?: unknown, replaceParent?: string): string {
	return "@twin.org/nameof-transformer is not in the build pipeline, you need to use a compiler that supports transformer plugins.";
}

/**
 * Placeholder method which substitutes the type name as a string at runtime.
 * @param property The property to get the name of.
 * @param replaceParent Optional object name to replace the top level object of a property path.
 * @returns The type name as a string.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function nameofKebabCase<T>(property?: unknown, replaceParent?: string): string {
	return "@twin.org/nameof-transformer is not in the build pipeline, you need to use a compiler that supports transformer plugins.";
}

/**
 * Placeholder method which substitutes the type name as a string at runtime.
 * @param property The property to get the name of.
 * @param replaceParent Optional object name to replace the top level object of a property path.
 * @returns The type name as a string.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function nameofCamelCase<T>(property?: unknown, replaceParent?: string): string {
	return "@twin.org/nameof-transformer is not in the build pipeline, you need to use a compiler that supports transformer plugins.";
}
